let sceneType = {};

sceneType.getData = function() {
	var data = [
		{
			value : 1000,
			name : "其他",
		},
		{
			value : 1001,
			name : "微信任务栏",
		},
		{
			value : 1005,
			name : "微信搜索",
		},
		{
			value : 1006,
			name : "微信搜索",
		},
		{
			value : 1007,
			name : "微信聊天会话",
		},
		{
			value : 1008,
			name : "微信聊天会话",
		},
		{
			value : 1010,
			name : "其他",
		},
		{
			value : 1011,
			name : "扫描二维码",
		},
		{
			value : 1012,
			name : "扫描二维码",
		},
		{
			value : 1013,
			name : "扫描二维码",
		},
		{
			value : 1014,
			name : "其他",
		},
		{
			value : 1017,
			name : "其他",
		},
		{
			value : 1019,
			name : "其他",
		},
		{
			value : 1020,
			name : "公众号菜单",
		},
		{
			value : 1022,
			name : "其他",
		},
		{
			value : 1023,
			name : "其他",
		},
		{
			value : 1024,
			name : "其他",
		},
		{
			value : 1025,
			name : "扫描二维码",
		},
		{
			value : 1026,
			name : "其他",
		},
		{
			value : 1027,
			name : "微信搜索",
		},
		{
			value : 1028,
			name : "其他",
		},
		{
			value : 1029,
			name : "其他",
		},
		{
			value : 1030,
			name : "其他",
		},
		{
			value : 1031,
			name : "扫描二维码",
		},
		{
			value : 1032,
			name : "扫描二维码",
		},
		{
			value : 1034,
			name : "其他",
		},
		{
			value : 1035,
			name : "公众号菜单",
		},
		{
			value : 1036,
			name : "其他",
		},
		{
			value : 1037,
			name : "其他",
		},
		{
			value : 1038,
			name : "其他",
		},
		{
			value : 1039,
			name : "其他",
		},
		{
			value : 1042,
			name : "微信搜索",
		},
		{
			value : 1043,
			name : "公众号会话",
		},
		{
			value : 1044,
			name : "其他",
		},
		{
			value : 1045,
			name : "其他",
		},
		{
			value : 1046,
			name : "其他",
		},
		{
			value : 1047,
			name : "扫描二维码",
		},
		{
			value : 1048,
			name : "扫描二维码",
		},
		{
			value : 1049,
			name : "扫描二维码",
		},
		{
			value : 1052,
			name : "其他",
		},
		{
			value : 1053,
			name : "微信搜索",
		},
		{
			value : 1054,
			name : "微信搜索",
		},
		{
			value : 1056,
			name : "其他",
		},
		{
			value : 1057,
			name : "其他",
		},
		{
			value : 1058,
			name : "公众号文章",
		},
		{
			value : 1059,
			name : "其他",
		},
		{
			value : 1060,
			name : "其他",
		},
		{
			value : 1064,
			name : "其他",
		},
		{
			value : 1065,
			name : "其他",
		},
		{
			value : 1067,
			name : "公众号文章",
		},
		{
			value : 1068,
			name : "其他",
		},
		{
			value : 1069,
			name : "其他",
		},
		{
			value : 1071,
			name : "其他",
		},
		{
			value : 1072,
			name : "其他",
		},
		{
			value : 1073,
			name : "其他",
		},
		{
			value : 1074,
			name : "公众号会话",
		},
		{
			value : 1077,
			name : "其他",
		},
		{
			value : 1078,
			name : "其他",
		},
		{
			value : 1079,
			name : "其他",
		},
		{
			value : 1081,
			name : "其他",
		},
		{
			value : 1082,
			name : "公众号会话",
		},
		{
			value : 1084,
			name : "其他",
		},
		{
			value : 1088,
			name : "其他",
		},
		{
			value : 1089,
			name : "微信任务栏",
		},
		{
			value : 1090,
			name : "其他",
		},
		{
			value : 1091,
			name : "公众号文章",
		},
		{
			value : 1092,
			name : "其他",
		},
		{
			value : 1095,
			name : "其他",
		},
		{
			value : 1096,
			name : "其他",
		},
		{
			value : 1097,
			name : "其他",
		},
		{
			value : 1099,
			name : "其他",
		},
		{
			value : 1100,
			name : "其他",
		},
		{
			value : 1101,
			name : "其他",
		},
		{
			value : 1102,
			name : "公众号菜单",
		},
		{
			value : 1103,
			name : "其他",
		},
		{
			value : 1104,
			name : "微信任务栏",
		},
		{
			value : 1106,
			name : "微信搜索",
		},
		{
			value : 1107,
			name : "其他",
		},
		{
			value : 1113,
			name : "其他",
		},
		{
			value : 1114,
			name : "其他",
		},
		{
			value : 1119,
			name : "其他",
		},
		{
			value : 1120,
			name : "其他",
		},
		{
			value : 1121,
			name : "其他",
		},
		{
			value : 1124,
			name : "扫描二维码",
		},
		{
			value : 1125,
			name : "其他",
		},
		{
			value : 1126,
			name : "扫描二维码",
		},
		{
			value : 1129,
			name : "其他",
		},
		{
			value : 1131,
			name : "其他",
		},
		{
			value : 1133,
			name : "其他",
		},
		{
			value : 1135,
			name : "其他",
		},
		{
			value : 1144,
			name : "公众号文章",
		},
		{
			value : 1145,
			name : "其他",
		},
		{
			value : 1146,
			name : "其他",
		},
		{
			value : 1148,
			name : "其他",
		},
		{
			value : 1150,
			name : "扫描二维码",
		},
		{
			value : 1151,
			name : "其他",
		},
		{
			value : 1152,
			name : "其他",
		},
		{
			value : 1153,
			name : "其他",
		},
		{
			value : 1154,
			name : "其他",
		},
		{
			value : 1155,
			name : "其他",
		},
		{
			value : 1157,
			name : "其他",
		},
		{
			value : 1158,
			name : "其他",
		},
		{
			value : 1160,
			name : "其他",
		},
		{
			value : 1167,
			name : "其他",
		},
		{
			value : 1168,
			name : "其他",
		},
		{
			value : 1169,
			name : "其他",
		},
		{
			value : 1171,
			name : "其他",
		},
		{
			value : 1173,
			name : "其他",
		},
		{
			value : 1175,
			name : "其他",
		},
		{
			value : 1176,
			name : "其他",
		},
		{
			value : 1177,
			name : "其他",
		},
		{
			value : 1178,
			name : "其他",
		},
		{
			value : 1179,
			name : "其他",
		},
		{
			value : 1181,
			name : "其他",
		},
		{
			value : 1183,
			name : "微信搜索",
		},
		{
			value : 1184,
			name : "其他",
		},
		{
			value : 1185,
			name : "其他",
		},
		{
			value : 1186,
			name : "其他",
		},
		{
			value : 1187,
			name : "其他",
		},
		{
			value : 1189,
			name : "其他",
		},
		{
			value : 1191,
			name : "其他",
		},
		{
			value : 1192,
			name : "其他",
		},
		{
			value : 1193,
			name : "其他",
		},
		{
			value : 1194,
			name : "其他",
		},
		{
			value : 1195,
			name : "其他",
		},
		{
			value : 1196,
			name : "其他",
		},
		{
			value : 1197,
			name : "其他",
		},
		{
			value : 1198,
			name : "其他",
		},
		{
			value : 1201,
			name : "其他",
		},
		{
			value : 1202,
			name : "其他",
		},
		{
			value : 1203,
			name : "其他",
		},
		{
			value : 1206,
			name : "其他",
		},
		{
			value : 1207,
			name : "其他",
		},
		{
			value : 1208,
			name : "其他",
		},
		{
			value : 1212,
			name : "其他",
		},
		{
			value : 1215,
			name : "其他",
		},
		{
			value : 1216,
			name : "其他",
		},
	];
	return data;
};

export default sceneType;



// WEBPACK FOOTER //
// ./src/utils/SceneType.js